<template>
  <div>
    <div
      class="loadingWrapper"
      >
      <div class="preloader loading">
        <span class="slice" />
          <span class="slice" />
            <span class="slice" />
              <span class="slice" />
                <span class="slice" />
                  <span class="slice" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
}
</script>
